import _ from 'lodash';
export var MEDIA_BASE_URL = 'https://static.wixstatic.com/media/';
export var EMPTY_MENU = Object.freeze({
    sections: [],
    items: [],
    chargesV2: [],
});
export var EMPTY_ADDRESS = Object.freeze({
    formatted: '',
    latLng: {
        lat: 0,
        lng: 0,
    },
});
export var EMPTY_RESTAURANT = Object.freeze({
    type: 'restaurant',
    id: '',
    externalIds: {},
    created: 0,
    modified: 0,
    title: { en_US: '' },
    description: {},
    contact: { email: '', phone: '' },
    address: EMPTY_ADDRESS,
    timezone: '',
    currency: '',
    locale: '',
    locales: [''],
    properties: {},
    media: {},
    distributorId: '',
    openTimes: {},
    deliveryInfos: [],
    paymentTypes: [],
    creditcardsInfo: { networks: [], fields: [], comment: {} },
    deliveriesInfo: { approximateAddresses: 'allow' },
    orders: {
        availability: {},
        asap: { preOrderMins: 0 },
        future: { disabled: false, delayMins: { min: 0, max: 0 } },
        properties: {},
    },
    reservations: {
        pendingApproval: true,
        partySize: { min: 0, max: 0 },
        availability: {},
        futureDelayMins: { min: 0, max: 0 },
        heldForMins: 0,
        properties: {},
    },
});
export var EMPTY_CONTACT = Object.freeze({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
});
// eslint-disable-next-line no-shadow
export var Modals;
(function (Modals) {
    Modals["DISH_MODAL"] = "DISH_MODAL";
    Modals["ORDER_SUBMITTED_MODAL"] = "ORDER_SUBMITTED_MODAL";
    Modals["ORDER_FAILURE_MODAL"] = "ORDER_FAILURE_MODAL";
    Modals["DISPATCH_SETTINGS_MODAL"] = "DISPATCH_SETTINGS_MODAL";
    Modals["CART_MODAL"] = "CART_MODAL";
    Modals["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    Modals["PRIVACY_POLICY"] = "PRIVACY_POLICY";
})(Modals || (Modals = {}));
// eslint-disable-next-line no-shadow
export var Screens;
(function (Screens) {
    Screens["INITIAL_VIEW"] = "INITIAL_VIEW";
    Screens["CHECKOUT_FLOW"] = "CHECKOUT_FLOW";
    Screens["THANK_YOU"] = "THANK_YOU";
})(Screens || (Screens = {}));
export var NO_ADDRESS = '[noskip]';
export var DEFAULT_ADDRESS = '500 Terry A Francois Boulevard, San Francisco, CA 94158, United States number = 500';
export var DEFAULT_ADDRESS_SHORT = '500 Terry Francois Street, San Francisco, CA, USA';
export var DISPATCH_MODAL_IN_OOI_QUERY_PARAM = 'dispatchType';
// eslint-disable-next-line no-shadow
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["CURBSIDE_PICKUP_UNAVAILABLE"] = 7006] = "CURBSIDE_PICKUP_UNAVAILABLE";
    ErrorCodes[ErrorCodes["PICKUP_UNAVAILABLE"] = 1002] = "PICKUP_UNAVAILABLE";
    ErrorCodes[ErrorCodes["DELIVERY_UNAVAILABLE"] = 1001] = "DELIVERY_UNAVAILABLE";
    ErrorCodes[ErrorCodes["PRICE_UPDATE"] = 1003] = "PRICE_UPDATE";
    ErrorCodes[ErrorCodes["PROMO_CODE_UPDATE"] = 1004] = "PROMO_CODE_UPDATE";
    ErrorCodes[ErrorCodes["DISCOUNT_UPDATE"] = 1006] = "DISCOUNT_UPDATE";
    ErrorCodes[ErrorCodes["VARIATION_PRICE_UPDATE"] = 1013] = "VARIATION_PRICE_UPDATE";
    ErrorCodes[ErrorCodes["TOGGLE_OFF_CHARGE"] = 2017] = "TOGGLE_OFF_CHARGE";
    ErrorCodes[ErrorCodes["INVALID_USER_CONTACT_DETAILS"] = 3000] = "INVALID_USER_CONTACT_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_LAST_NAME_DETAILS"] = 3001] = "INVALID_USER_LAST_NAME_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_FIRST_NAME_DETAILS"] = 3002] = "INVALID_USER_FIRST_NAME_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_PHONE_DETAILS"] = 3003] = "INVALID_USER_PHONE_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_COMMUNICATION_DETAILS"] = 3004] = "INVALID_USER_COMMUNICATION_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_MIN_ORDER_PRICE"] = 4002] = "INVALID_MIN_ORDER_PRICE";
    ErrorCodes[ErrorCodes["RESTAURANTS_CLOSED"] = 5002] = "RESTAURANTS_CLOSED";
    ErrorCodes[ErrorCodes["USER_PAYMENT_CANCELED"] = 5003] = "USER_PAYMENT_CANCELED";
    ErrorCodes[ErrorCodes["DINE_IN_UNAVAILABLE"] = 10001] = "DINE_IN_UNAVAILABLE";
    ErrorCodes[ErrorCodes["DINE_IN_AND_CURBSIDE_HAVE_BEEN_SUBMITTED"] = 9001] = "DINE_IN_AND_CURBSIDE_HAVE_BEEN_SUBMITTED";
    ErrorCodes[ErrorCodes["ORDER_PRICE_BELOW_MIN_PICKUP_ORDER_PRICE"] = 9002] = "ORDER_PRICE_BELOW_MIN_PICKUP_ORDER_PRICE";
    ErrorCodes[ErrorCodes["DINE_IN_MISSING_LABEL"] = 10003] = "DINE_IN_MISSING_LABEL";
    ErrorCodes[ErrorCodes["DINE_IN_MISSING_LABEL_VALUE"] = 10002] = "DINE_IN_MISSING_LABEL_VALUE";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_IS_LESS_THEN_DELIVETY_DURATION"] = 1016] = "DELIVERY_TIME_IS_LESS_THEN_DELIVETY_DURATION";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_IS_MORE_THEN_MAX_DELIVETY_DURATION"] = 1017] = "DELIVERY_TIME_IS_MORE_THEN_MAX_DELIVETY_DURATION";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_CANNOT_PRECEDE"] = 1018] = "DELIVERY_TIME_CANNOT_PRECEDE";
    ErrorCodes[ErrorCodes["ITEM_UNAVAILABLE_FOR_FULFILLMENT_METHOD"] = 1019] = "ITEM_UNAVAILABLE_FOR_FULFILLMENT_METHOD";
    ErrorCodes[ErrorCodes["LOYALTY_MISSING_REQUIRED_FIELD"] = 8001] = "LOYALTY_MISSING_REQUIRED_FIELD";
    ErrorCodes[ErrorCodes["LOYALTY_FEATURE_CLOSED"] = 8002] = "LOYALTY_FEATURE_CLOSED";
    ErrorCodes[ErrorCodes["LOYALTY_INSUFFICIENT_BALANCE"] = 8003] = "LOYALTY_INSUFFICIENT_BALANCE";
    ErrorCodes[ErrorCodes["LOYALTY_INVALID_POINTS_AMOUNT"] = 8004] = "LOYALTY_INVALID_POINTS_AMOUNT";
    ErrorCodes[ErrorCodes["LOYALTY_REWARD_NOT_ACTIVE"] = 8005] = "LOYALTY_REWARD_NOT_ACTIVE";
    ErrorCodes[ErrorCodes["LOYALTY_UNSUPPORTED_DISCOUNT_TYPE"] = 8006] = "LOYALTY_UNSUPPORTED_DISCOUNT_TYPE";
    ErrorCodes[ErrorCodes["LOYALTY_POINTS_REQUIRED"] = 8007] = "LOYALTY_POINTS_REQUIRED";
    ErrorCodes[ErrorCodes["LOYALTY_UNEXPECTED_CHARGES_AMOUNT"] = 8008] = "LOYALTY_UNEXPECTED_CHARGES_AMOUNT";
    ErrorCodes[ErrorCodes["LOYALTY_FAILED_TO_REDEEM_POINTS"] = 8009] = "LOYALTY_FAILED_TO_REDEEM_POINTS";
    ErrorCodes[ErrorCodes["TOGGLE_OFF_CASH"] = 12001] = "TOGGLE_OFF_CASH";
    ErrorCodes[ErrorCodes["FEE_DOESNT_MATCH"] = 11005] = "FEE_DOESNT_MATCH";
    ErrorCodes[ErrorCodes["DELIVERY_ESTIMATION_REJECTED_BY_PROVIDER"] = 11015] = "DELIVERY_ESTIMATION_REJECTED_BY_PROVIDER";
    ErrorCodes[ErrorCodes["MISSING_REQUIRED_FIELD_TPA"] = 11001] = "MISSING_REQUIRED_FIELD_TPA";
    ErrorCodes[ErrorCodes["CURRENCY_NOT_MATCH_TPA"] = 11006] = "CURRENCY_NOT_MATCH_TPA";
    ErrorCodes[ErrorCodes["DELIVERED_BY_RESTAURANT_TPA"] = 11012] = "DELIVERED_BY_RESTAURANT_TPA";
    ErrorCodes[ErrorCodes["UNSUPPORTED_PAYMENT_TPA"] = 11017] = "UNSUPPORTED_PAYMENT_TPA";
    ErrorCodes[ErrorCodes["SERVICE_FEES_MISSING_REQUIRED_FIELD"] = 16001] = "SERVICE_FEES_MISSING_REQUIRED_FIELD";
    ErrorCodes[ErrorCodes["SERVICE_FEES_INVALID_FIELD"] = 16002] = "SERVICE_FEES_INVALID_FIELD";
    ErrorCodes[ErrorCodes["SERVICE_FEES_FEE_CALCULATION_FAILED"] = 16003] = "SERVICE_FEES_FEE_CALCULATION_FAILED";
    ErrorCodes[ErrorCodes["SERVICE_FEES_INVALID_SERVICE_FEE"] = 16004] = "SERVICE_FEES_INVALID_SERVICE_FEE";
})(ErrorCodes || (ErrorCodes = {}));
export var SERVERLESS_BASEURL = typeof window !== 'undefined'
    ? _.get(window, 'location.hostname') || 'manage.wix.com'
    : 'manage.wix.com';
export var ORDER_PACING = {
    interval: 15,
    maxVisibleLevel: 3,
    maxVisibleTimeForRange: 2 * 60,
};
export var PERIODS_IN_MILLISECONDS = {
    day: 1000 * 60 * 60 * 24,
};
export var ORDERS_APP_ID = '13e8d036-5516-6104-b456-c8466db39542';
export var MENUS_APP_ID = '13c1402c-27f2-d4ab-7463-ee7c89e07578';
export var KIT_APP_ID = '14583ff5-e781-063a-3bc4-6b79fb966992';
export var SEATING_APP_ID = '1475ab65-206b-d79a-856d-fa10bdb479ea';
export var ORDERS_DEV_APP_ID = '13a2d835-34bd-a50b-c634-c9158ba38c0d';
export var REST_APP_ID = '05509e60-039b-471d-8af1-790b51277410';
//# sourceMappingURL=constants.js.map